import {
  Autocomplete,
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Stack,
  TextField,
  Typography,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  RadioGroup,
  FormControlLabel,
  Radio,
} from "@mui/material";
import React, { useContext, useEffect, useState } from "react";
import AgreementInfo from "./AgreementInfo";
import EquipmentsTable from "./EquipmentsTable";
import { AuthContext } from "../AuthContext";
import {
  addAgreementEquipments,
  getAgreementEquipmentsList,
  submitAgreementEquipments,
  fetchSTLocationsByAddress,
  fetchAgreementFromJBById,
} from "../services/agreementServices";
import TblProductsSearch from "./TblProductsSearch";
import { getTblProductsSearch } from "../services/TblProductsServices";

import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import dayjs from "dayjs";


const AgreementEquimentDialog = ({
  agreement,
  open,
  onClose,
  optype,
  productCode,
  poNumber,
  onAgreementInfoUpdate,
  isEmPhUpdated,
  isNameUpdated,
  isAddressUpdated,
  onPlanChange,
  onEnableCustomerNameEdit, onEnablePhoneEmailEdit,
  onEnableLocationEdit,
  dealer
}) => {
  const { user, ctxStEquipments, setCtxStEquipments, APP_ENV, group } =
    useContext(AuthContext);
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [syncError, setSyncError] = useState("");
  const [saveError, setSaveError] = useState("");
  const [agrProductCode, setAgreProductCode] = useState(null);
  const [agrPoNumber, setAgrPoNumber] = useState(null);
  const [loadingMsg, setLoadingMsg] = useState("");
  const [disableSaveBtn, setDisableSaveBtn] = useState(false);
  const [disableCancelBtn, setDisableCancelBtn] = useState(false);
  const [eqiGrid, setEquiGrid] = useState(false);
  const [newBtn, setNewBtn] = useState(false);
  const [orgEquiments, setOrgEquipments] = useState([]);
  const [saveMsg, setSaveMsg] = useState("");
  const [isRenewedAgreementVerified, setIsRenewedAgreementVerified] = useState(false);
  const [searchResults, setSearchResults] = useState([]);
  const [searchLoading, setSearchLoading] = useState(false);
  const [allowedUnits, setAllowedUnits] = useState(agreement?.equipmentUnits || 0);
  const [installedDate, setInstalledDate] = useState(
    dayjs(agreement.startDate)
  );
  // Added configurable Installed Date validation for Add/Edit Equipment using SKU-specific installDateValidity.
  const [installDateValidity, setInstallDateValidity] = useState(2);
  const [installedDateError, setInstalledDateError] = useState("");
  const [isProductValid, setIsProductValid] = useState(true);
  const [dealerMismatchPopup, setDealerMismatchPopup] = useState(false);
  const [mismatchDealerInfo, setMismatchDealerInfo] = useState(null);
  const [mismatchAgreementData, setMismatchAgreementData] = useState(null);
  const [renewedAgreementError, setRenewedAgreementError] = useState("");
  const [searchType, setSearchType] = useState("address");
  const [planDescription, setPlanDescription] = useState("");
  const [disableConfirmBtn, setDisableConfirmBtn] = useState(false);
  const [showLocationSearch, setShowLocationSearch] = useState(false);
  const [searchAddress, setSearchAddress] = useState({
    addressLine1: "",
    addressLine2: "",
    city: "",
    state: "",
    zipcode: "",
    customerId: "",
    unit: "",
  });
  const [originalPlanId, setOriginalPlanId] = useState("");
  const [originalPlanError, setOriginalPlanError] = useState("");
  const [parentSKUs, setParentSKUs] = useState([]);
  const [currentParentDescription, setCurrentParentDescription] = useState("");
  const isDealer = group === "jbw-dealer";
  const isExceedingLimit =
    isDealer &&
    allowedUnits > 0 &&
    ctxStEquipments.length > allowedUnits;
  const [isRenewalPlan, setIsRenewalPlan] = useState(0);
  const [showOriginalPlanField, setShowOriginalPlanField] = useState(false);
  const resetSearchState = () => {
    setSearchAddress({
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      zipcode: "",
      customerId: "",
      unit: "",
    });

    setSearchResults([]);
    setSearchType("address"); // default
    setSearchLoading(false);
  };

  const [renewedAgreementInput, setRenewedAgreementInput] = useState("");
  const [renewedAgreementOptions, setRenewedAgreementOptions] = useState([]);
  const [selectedRenewedAgreement, setSelectedRenewedAgreement] = useState("");
  const [showRenewedDropdown, setShowRenewedDropdown] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);
  const JB_FETCH_ID = "JB-DATA-1";
  const isAdminWithJBWAgreement =
    group === "jbw-admin" && !!agreement?.jbwAgreementId;

  useEffect(() => {
    setSearchAddress({
      addressLine1: "",
      addressLine2: "",
      city: "",
      state: "",
      zipcode: "",
      customerId: "",
      unit: "",
    });
  }, [searchType]);


  useEffect(() => {
    if (isRenewalPlan === 1 && parentSKUs.length === 0) {
      console.warn("Renewed plan but no parent SKUs available");
    }
  }, [isRenewalPlan, parentSKUs]);

  useEffect(() => {
    if (!agreement) return;

    setIsRenewalPlan(agreement.isRenewalPlan || 0);
    const parentCode = agreement?.parentProductCode;

    if (
      parentCode &&
      parentCode !== "undefined" &&
      parentCode.trim() !== ""
    ) {
      setOriginalPlanId(parentCode);
      setShowOriginalPlanField(true);
    } else {
      setOriginalPlanId("");
      setShowOriginalPlanField(false);
    }
    if (
      agreement.parentProductDescription &&
      agreement.parentProductDescription.trim() !== ""
    ) {
      setCurrentParentDescription(agreement.parentProductDescription);
    } else {
      setCurrentParentDescription("");
    }
  }, [agreement]);

  useEffect(() => {
    if (agreement?.productDescription) {
      setPlanDescription(agreement.productDescription);
    }
  }, [agreement]);

  useEffect(() => {
    if (!agreement || !open || isRenewalPlan !== 1) return;

    const value = agreement.renewedAgreementId;

    if (!value) {
      setShowRenewedDropdown(false);
      setRenewedAgreementInput("");
      setRenewedAgreementOptions([]);
      setSelectedRenewedAgreement("");
      return;
    }

    const ids = value.split(",").map(v => v.trim()).filter(Boolean);

    if (ids.length === 1) {
      setShowRenewedDropdown(false);
      setRenewedAgreementInput(String(ids[0]));
      setSelectedRenewedAgreement("");
    } else {
      setShowRenewedDropdown(true);
      setRenewedAgreementOptions(ids);
      setSelectedRenewedAgreement(ids[0]); // default select
      setRenewedAgreementInput("");
    }

  }, [agreement?.id, open, isRenewalPlan]); // use id, not whole object

  const handleFetchRenewedAgreement = async () => {
    setRenewedAgreementError("");
    const idToFetch = showRenewedDropdown
      ? selectedRenewedAgreement
      : renewedAgreementInput?.trim();

    if (!idToFetch) {
      setSaveError("Please enter/select Agreement Id");
      return;
    }

    setFetchLoading(true);
    setSaveError("");

    try {
      const res = await fetchAgreementFromJBById(idToFetch);

      if (res?.status !== 200) {
        throw new Error("Unexpected response from server");
      }

      const data = res?.data?.data;
      if (data?.dealer?.id !== dealer?.dealerId) {

        setFetchLoading(false);
        setMismatchAgreementData(data);
        setMismatchDealerInfo({
          enteredDealerId: data?.dealer?.id,
          enteredDealerName: data?.dealer?.name,
          selectedDealerId: dealer?.dealerId,
          selectedDealerName: dealer?.dealerName,
        });
        setDealerMismatchPopup(true);

        // stop further processing until user confirms
        return;
      }

      processRenewedAgreement(data);

    }
    catch (err) {
      console.error(err);
      setDisableSaveBtn(true);
      setDisableConfirmBtn(true);
      if (err.response) {

        const status = err.response.status;
        const apiMessage = err.response.data;
        // Custom handling for unauthorized
        if (
          status === 403 &&
          apiMessage === "This action is unauthorized."
        ) {
          setRenewedAgreementError(
            "Invalid agreement ID or unauthorized request."
          );
        } else if (status === 404
        ) {
          setRenewedAgreementError(
            "Invalid agreement ID, Agreement not found in JB."
          );
        } else {
          setSaveError(
            `Request failed (${status}): ${apiMessage || "Something went wrong"
            }`
          );
        }
      }
      else if (err.request) {
        setSaveError(
          "Unable to reach the server. Please check your connection and try again."
        );
      }
      else {
        setSaveError(
          err.message || "An unexpected error occurred."
        );
      }
    }
    finally {
      setFetchLoading(false);
    }
  };

  const processRenewedAgreement = (data) => {

    setIsRenewedAgreementVerified(true);

    if (data?.expiration_date) {
      const expiry = dayjs(data.expiration_date);
      const today = dayjs();
      const diffDays = expiry.diff(today, "day");

      if (diffDays <= 30) {
        setSaveError("Plan is within 30 days or expired and can't be renewed");
        setDisableSaveBtn(true);
        setDisableConfirmBtn(true);
        return;
      } else {
        setDisableSaveBtn(false);
        setDisableConfirmBtn(false);
      }
    }

    const productCode = data?.product?.code;

    if (
      productCode &&
      productCode !== "undefined" &&
      productCode.trim() !== ""
    ) {
      setOriginalPlanId(productCode);
      setShowOriginalPlanField(true);
    } else {
      setOriginalPlanId("");
      setShowOriginalPlanField(false);
    }
    setNewBtn(false);
    setLoadingMsg("");
    setCurrentParentDescription(
      data?.product?.description || ""
    );

    if (
      data?.product?.code &&
      !parentSKUs.includes(data.product.code)
    ) {
      setOriginalPlanError(
        "Original coverage purchased is not eligible for renewal. Please contact your JBW Sales Rep for more information."
      );
    } else {
      setOriginalPlanError("");
    }

    if (data?.startup_date) {
      setInstalledDate(dayjs(data.startup_date));
    }

    setEquiGrid(true);

    const jbRows = mapJBEquipment(data.equipments || []);

    setCtxStEquipments(prev => {
      // Remove previously fetched JB equipment
      const filtered = prev.filter(
        eq => eq.fetchSourceId !== JB_FETCH_ID
      );

      const updatedEquipments = [
        ...filtered,
        ...jbRows
      ];

      console.log("Updated Equipments:", updatedEquipments);

      return updatedEquipments;
    });
  };

  const isRenewedAgreementInvalid =
    isRenewalPlan === 1 &&
    (
      showRenewedDropdown
        ? !selectedRenewedAgreement
        : !renewedAgreementInput?.trim()
    );

  useEffect(() => {
    if (!agreement?.productCode) return;

    getTblProductsSearch(agreement.productCode).then((res) => {
      const product = Array.isArray(res.data) ? res.data[0] : res.data;
      if (!product) return;

      if (product?.installDateValidity) {
        setInstallDateValidity(product?.installDateValidity);
        validateInstalledDate(installedDate, product.installDateValidity);
      }
      // Store the full objects from the API
      const fullParentList = product.parentProducts || [];

      // Set the SKU options for the dropdown
      const skuList = fullParentList.map(p => p.parentSKU).filter(Boolean);
      setParentSKUs(skuList);
    });
  }, [agreement?.productCode]);

  const isSearchDisabled =
    (searchType === "customerId" && !searchAddress.customerId) ||
    (searchType === "address" && !searchAddress.addressLine1);

  console.log("select agreement : ", agreement);
  console.log("selected dealer : ", dealer);

  useEffect(() => {
    setAgreProductCode(productCode);
  }, [productCode]);

  useEffect(() => {
    setAgrPoNumber(poNumber);
  }, [poNumber]);

  const getEquipments = (agreementId) => {
    setDisableSaveBtn(true);
    setDisableConfirmBtn(true);
    console.log("AgmEquiplmentDialog", agreementId);
    setCtxStEquipments([]);
    setNewBtn(false);
    setLoadingMsg("Loading Equipment. Please Wait..");
    getAgreementEquipmentsList(agreementId)
      .then(
        (res) => {
          const eqList = APP_ENV === "Development" ? res.data.body : res.data;
          const statusCode = res.status;
          if (statusCode === 200) {
            console.log("AgmEquiplmentDialog equipment list :", eqList);
            if (eqList && eqList.length > 0) {
              setCtxStEquipments(eqList);
              setOrgEquipments(eqList);
              setLoadingMsg("");
              setEquiGrid(true);
              setDisableSaveBtn(
                (eqList.length > allowedUnits) && isDealer ? true : false
              );
              setDisableConfirmBtn((eqList.length > allowedUnits) && isDealer ? true : false);
            } else {
              setLoadingMsg("No Equipment found");
              setNewBtn(true);
              setDisableSaveBtn(true);
              setDisableConfirmBtn(true);
            }
          }
        },
        (err) => {
          console.log("unable to load equipment list", err);
          setSaveError("unable to load equipment list");
        }
      )
      .catch((err) => {
        console.log("Equipment List Internal Server Error", err);
        setSaveError("Internal Server error");
      });
  };

  useEffect(() => {
    if (optype === "update") {
      getEquipments(agreement?.id);
    } else {
      setEquiGrid(true);
    }
  }, [agreement?.id, optype]);

  useEffect(() => {
    if (open) {
      resetSearchState(); // always fresh when dialog opens
    }
  }, [open]);

  const handleClose = (event, reason) => {
    if (reason === "escapeKeyDown" || reason === "backdropClick") {
      return;
    }

    resetSearchState(); //  ADD THIS
    setShowLocationSearch(false); // also reset view

    setEquiGrid(false);
    setRenewedAgreementInput("");
    setRenewedAgreementOptions([]);
    setSelectedRenewedAgreement("");
    setShowRenewedDropdown(false);
    setDealerMismatchPopup(false);
    setMismatchDealerInfo(null);
    setMismatchAgreementData(null);
    onClose();
  };

  const handleProductSelected = (param) => {
    if (param == null) {
      setDisableSaveBtn(true);
      setDisableConfirmBtn(true);
      return;
    }
    setAgreProductCode(param.productCode);

    // update plan description
    setPlanDescription(param.description || "");
    // THIS is where API response is used
    setIsRenewalPlan(param.isRenewalPlan || 0);
    // Store full objects and derive SKUs
    const fullParentList = param?.parentProducts || [];
    const newAllowedUnits = param.maxUnits || 0;
    setAllowedUnits(newAllowedUnits);
    if (isExceedingLimit) {
      setDisableSaveBtn(true);
      setDisableConfirmBtn(true);
      setSaveError("Equipment count exceeds allowed units after product change");
    } else {
      setSaveError("");
    }
    if (param.installDateValidity) {
      setInstallDateValidity(param.installDateValidity);
      validateInstalledDate(installedDate, param.installDateValidity);
    }
    const skuList = fullParentList.map(p => p.parentSKU).filter(Boolean);
    setParentSKUs(skuList);
    console.log(" setParentSKUs", skuList);
    if (originalPlanId &&
      !skuList.includes(originalPlanId)
    ) {
      setOriginalPlanError(
        "Original coverage purchased is not eligible for renewal. Please contact your JBW Sales Rep for more information."
      );
    } else {
      setOriginalPlanError("");
    }
  };

  const isOriginalPlanInvalid =
    isRenewalPlan === 1 &&
    (
      !!originalPlanError ||
      !originalPlanId?.trim()
    );

  const handlePoNumberChange = (args) => {
    console.log("PoNumber change :", args);
    setAgrPoNumber(args);
  };

  const handleSubmitAgreement = () => {
    if (isExceedingLimit) {
      setSyncError(
        `Equipment count cannot exceed allowed units (${allowedUnits})`
      );
      return;
    }
    setFormSubmitted(true);

    submitAgreementEquipments(agreement?.id)
      .then((res) => {
        const statusCode = res.status;

        if (statusCode === 200) {
          onClose("success"); // Close screen after submit
        } else {
          setSyncError("Unable to Submit Equipment");
          setFormSubmitted(false);
        }
      })
      .catch((err) => {
        console.error("Equipment Submit internal server error :", err);
        setSyncError("Internal server error");
        setFormSubmitted(false);
      });
  };

  const mapJBEquipment = (equipmentList = []) => {
    return equipmentList.map((eq, index) => ({
      id: `${Date.now()}-${index}`, // unique temp id

      equipmentTypeId: eq.type_id || 0,
      agreementId: agreement.id,
      manufacturer: eq.manufacturer || "",
      modelNo: eq.model_number || "",
      serialNumber: eq.serial_number || "",

      equipmentType: "new",
      isEditMode: false,
      isNew: true,
      fetchSourceId: JB_FETCH_ID,
      createdBy: user.name,
      isDeleted: 0,
      source: "JB",
      dataReceivedFromST: 1,
      // NEW REQUIRED FIELDS
      locationId: agreement?.locationId,
      invoiceId: agreement?.invoiceId || null, // adjust if needed
      dealerId: dealer?.id,
      tenantId: agreement?.tenantId,
    }));
  };
  const handleSubmitClick = () => {
    handleSave(true);
  };
  const handleSave = (isSubmit = false) => {
    setSaveMsg("Saving Equipment Please wait...");

    let eqList = ctxStEquipments;
    if (isExceedingLimit) {
      console.log("equipment list is greater than Allowed Equipment");
      setSaveMsg("equipment list is greater than Allowed Equipment");
      setSaveError(`Cannot exceed allowed units (${allowedUnits})`);
      setDisableSaveBtn(true);
      setDisableConfirmBtn(true);
      return;
    }
    setSaveError("");
    setDisableCancelBtn(true);
    setDisableSaveBtn(true);
    setDisableConfirmBtn(true);
    if (optype === "create") {
      eqList = eqList
        .map((eq) => ({ ...eq, id: "", createdBy: user.name }))
        .filter((eq) => eq.manufacturer !== null);
    } else {
      const saveEquIds = new Set(
        eqList.filter((eq) => eq.equipmentType !== "new").map((eq) => eq.id)
      );
      const deletedEquipments = orgEquiments
        .filter((oreq) => !saveEquIds.has(oreq.id))
        .map((eq) => {
          return { ...eq, isDeleted: 1 };
        });
      eqList = eqList
        .map((eq) => {
          if (eq.equipmentType === "new") {
            return { ...eq, id: "", createdBy: user.name };
          } else {
            return { ...eq, modifiedBy: user.name };
          }
        })
        .filter(
          (eq) =>
            eq.manufacturer !== null &&
            eq.manufacturer !== "null" &&
            eq.manufacturer.trim().length > 0
        );
      eqList = eqList.concat(deletedEquipments);
    }
    console.log("lenght of equipment list : ", eqList.length);
    if (!(eqList.length > 0)) {
      setSaveError("Please Enter Equipment Details.");
      setDisableCancelBtn(false);
      setDisableSaveBtn(false);
      setDisableConfirmBtn(false);
      setSaveMsg("");
      return;
    }
    console.log("json parse:", JSON.parse(JSON.stringify(eqList)));
    const renewedAgreementId =
      showRenewedDropdown
        ? selectedRenewedAgreement
        : renewedAgreementInput?.trim();
    const reqJson = {
      agreementId: agreement?.id,
      optype: optype,
      equipmentList: eqList,
      agrPoNumber,
      agrProductCode,
      installedDate,
      originalPlanId,
      renewedAgreementId,
    };
    addAgreementEquipments(agreement?.id, reqJson, optype)
      .then(
        (res) => {
          console.log("save data :", res.data);
          const statusCode = res.status;
          if (statusCode === 200) {
            setCtxStEquipments([]);
            setEquiGrid(false);
            setSaveMsg("");
            if (isSubmit) {
              console.log("  handle Submit method called");
              handleSubmitAgreement(); // Call submit after save
            } else {
              onClose("success");
            }
          } else {
            console.log("unable to save the equipment", res.data);
            setSaveError("Error in saving Equipment list");
            setDisableCancelBtn(false);
            setDisableSaveBtn(false);
            setDisableConfirmBtn(false);
          }
        },
        (err) => {
          console.log("unable to save the equipment", err);
          setSaveError("unable to save the Equipment");
          setDisableCancelBtn(false);
          setDisableSaveBtn(false);
          setDisableConfirmBtn(false);
          setSaveMsg("");
        }
      )
      .catch((err) => {
        console.error("Internal server error :", err);
        setSaveError("Internal Server error");
        setDisableCancelBtn(false);
        setDisableSaveBtn(false);
        setSaveMsg("");
      });
    //setSaveMsg("");
  };

  const handleAddEquipmentsGrid = () => {
    setEquiGrid(true);
    setNewBtn(false);
    setLoadingMsg("");
    setDisableSaveBtn(false);
    setDisableConfirmBtn(false);
  };

  const handleDateChange = (newDate) => {
    setInstalledDate(newDate);
    validateInstalledDate(newDate, installDateValidity);
    console.log(newDate);
  };
  const handleOnAgreementUnitSizeExceed = (value) => {
    console.log("group:", group, "value:", value);

    if (group !== "jbw-dealer") {
      setDisableSaveBtn(false);
      setDisableConfirmBtn(false);
      return;
    }

    setDisableSaveBtn(value);
    setDisableConfirmBtn(value);

  }
  const handleLocationSearch = async () => {
    setSearchLoading(true);

    let payload = {};

    if (searchType === "customerId") {
      payload = {
        customerId: searchAddress.customerId,
      };
    }

    if (searchType === "address") {
      payload = {
        addressLine1: searchAddress.addressLine1,
        unit: searchAddress.unit,
      };
    }

    const results = await fetchSTLocationsByAddress(
      payload,
      agreement.tenantId
    );

    setSearchResults(results || []);
    setSearchLoading(false);
  };
  const handleSearchInputChange = (field, value) => {
    setSearchAddress((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleLocationSelect = (row) => {

    const location = {
      infoType: "locationAddress",
      locationId: row.id,
      street: row.address?.street,
      unit: row.address?.unit,
      city: row.address?.city,
      state: row.address?.state,
      zipcode: row.address?.zip
    };
    console.log("Selected location:", location);
    onAgreementInfoUpdate(agreement.id, location);

    setShowLocationSearch(false); // return to main dialog
  };

  const validateInstalledDate = (date, validity) => {
    if (!date) return;

    const minAllowedDate = dayjs().subtract(validity, "year");

    if (dayjs(date).isBefore(minAllowedDate, "day")) {
      setInstalledDateError(
        "Installed Date is outside the allowed date range for the selected plan. Please choose a valid date."
      );

      setDisableSaveBtn(true);
      setDisableConfirmBtn(true);
    } else {
      setInstalledDateError("");

      setDisableSaveBtn(false);
      setDisableConfirmBtn(false);
    }
  };

  return (
    <>
      <Dialog
        onClose={handleClose}
        open={open}
        PaperProps={{
          component: "div",
        }}
        fullWidth={true}
        maxWidth={"xl"}
        disableEscapeKeyDown
      >

        <DialogTitle sx={{ m: 0, p: 2 }}>
          <Grid container spacing={2}>
            <Grid item xs={4}>
              {showLocationSearch
                ? "Search ST Location"
                : optype === "create"
                  ? "Add Equipment"
                  : "Edit Equipment"}
            </Grid>

            {/* RIGHT CONTENT */}
            {!showLocationSearch && (
              <Grid item xs={12} md={isRenewalPlan === 1 ? 12 : 9}>

                {/* ROW 1 */}
                <Stack direction="row" spacing={2} flexWrap="wrap">

                  <TextField
                    id="Po-no"
                    label="Invoice Number"
                    variant="standard"
                    value={agrPoNumber}
                    onChange={(e) => handlePoNumberChange(e.target.value)}
                  />
                  {/* NEW FIELD */}
                  {isRenewalPlan === 1 && (
                    <>
                      {!showRenewedDropdown ? (
                        <TextField
                          label="Renewable Agreement Id"
                          variant="standard"
                          required
                          error={
                            !renewedAgreementInput || !!renewedAgreementError
                          }
                          helperText={
                            renewedAgreementError ||
                            (!renewedAgreementInput
                              ? "An eligible 1, 2, 3 or 5-year plan must be purchased prior to purchasing a renewable plan. Please reach out to your JBW Sales Rep for more information."
                              : "")
                          }
                          FormHelperTextProps={{
                            sx: {
                              whiteSpace: "pre-line",
                              width: 260,
                              lineHeight: 1.3
                            }
                          }}
                          value={renewedAgreementInput || ""}
                          onChange={(e) => {
                            setRenewedAgreementInput(e.target.value);
                            setRenewedAgreementError("");
                            setIsRenewedAgreementVerified(false);
                          }}
                        />
                      ) : (
                        <Autocomplete
                          sx={{ width: 220 }}
                          options={renewedAgreementOptions}
                          value={
                            renewedAgreementOptions.includes(selectedRenewedAgreement)
                              ? selectedRenewedAgreement
                              : null
                          }
                          onChange={(e, val) => {
                            setSelectedRenewedAgreement(val || "");
                            setRenewedAgreementError("");
                            setIsRenewedAgreementVerified(false);
                          }}
                          renderInput={(params) => (
                            <TextField
                              {...params}
                              label="Select Agreement Id"
                              variant="standard"
                              required
                              error={
                                !selectedRenewedAgreement ||
                                !!renewedAgreementError
                              }
                              helperText={
                                renewedAgreementError ||
                                (!selectedRenewedAgreement
                                  ? "An eligible 1, 2, 3 or 5-year plan must be purchased prior \nto purchasing a renewable plan. Please reach out to your JBW Sales Rep for more information."
                                  : "")
                              }
                            />
                          )}
                        />
                      )}

                      <Button
                        variant="contained"
                        color="secondary"
                        size="small"
                        sx={{
                          minHeight: 30,
                          height: 30,
                          px: 1.5,
                          minWidth: 110,
                          fontSize: "0.75rem",
                          borderRadius: "16px",
                          textTransform: "none"
                        }}
                        onClick={handleFetchRenewedAgreement}
                        disabled={
                          fetchLoading || // disable while loading
                          (showRenewedDropdown
                            ? !selectedRenewedAgreement
                            : !renewedAgreementInput)
                        }
                      >
                        {fetchLoading ? "Fetching..." : "Fetch From JB"}
                      </Button>
                    </>
                  )}
                  {showOriginalPlanField && (
                    <TextField
                      label="Original Plan Id"
                      variant="standard"
                      value={originalPlanId &&
                        originalPlanId !== "undefined"
                        ? originalPlanId
                        : ""}
                      InputProps={{
                        readOnly: true,
                      }}
                      error={!!originalPlanError}
                      helperText={originalPlanError}
                      FormHelperTextProps={{
                        sx: {
                          whiteSpace: "pre-line",
                          width: 260,
                          lineHeight: 1.3,
                        },
                      }}
                    />
                  )}

                  <TblProductsSearch
                    searchValue={agrProductCode}
                    onProductSelected={handleProductSelected}
                    onProductFound={setIsProductValid} />
                  {(
                    <LocalizationProvider dateAdapter={AdapterDayjs}>
                      <DatePicker
                        label="Installed Date"
                        value={installedDate}
                        minDate={dayjs().subtract(installDateValidity, "year")}
                        maxDate={dayjs()}
                        onChange={handleDateChange}
                        disableFuture={true}
                        renderInput={(params) => (
                          <TextField
                            {...params}
                            variant="standard"
                            error={!!installedDateError}
                            helperText={installedDateError}
                            FormHelperTextProps={{
                              sx: {
                                whiteSpace: "normal",
                                width: 260,
                                lineHeight: 1.3,
                              },
                            }}
                            sx={{
                              "& .MuiOutlinedInput-root": {
                                height: "50px",
                              },
                              "& .MuiInputBase-input": {
                                height: "1.4375em",
                                padding: "5px 14px",
                              },
                            }} />
                        )} />
                    </LocalizationProvider>
                  )}
                </Stack>

                {/* ROW 2 */}
                <Stack direction="row" spacing={3} sx={{ mt: 2, ml: 4 }} flexWrap="wrap">


                  <Typography
                    variant="captiondo"
                    component="subtitle1"
                    align="left"
                    sx={{ fontSize: "14px" }}
                  >
                    {isRenewalPlan === 1
                      ? "Renewable Plan Description: "
                      : "Plan Description: "}
                    <Box component="span" sx={{ fontWeight: 400, color: "#2196F3" }}>
                      {planDescription}
                    </Box>
                  </Typography>
                  <Typography
                    variant="body2"
                    sx={{
                      fontSize: "14px",
                      color: "rgb(191, 54, 12)",
                      fontWeight: 500,
                    }}
                  >
                    Allowed Units :{" "}
                    <Box component="span" sx={{ fontWeight: 400, color: "#2196F3" }}>
                      {allowedUnits}
                    </Box>
                  </Typography>
                </Stack>

                {/* ROW 3 (ONLY renewed plan) */}
                {isRenewalPlan === 1 && currentParentDescription && (
                  <Stack direction="row" spacing={3} sx={{ mt: 1, ml: 4 }}>
                    <Typography
                      variant="body2"
                      sx={{
                        fontSize: "14px",
                        color: "rgb(191, 54, 12)",
                        fontWeight: 500,
                      }}
                    >
                      Original Plan Description:{" "}
                      <Box component="span" sx={{ fontWeight: 400, color: "#2196F3" }}>
                        {currentParentDescription}
                      </Box>
                    </Typography>
                  </Stack>
                )}

              </Grid>
            )}
          </Grid>
        </DialogTitle>

        <DialogContent dividers>
          {!showLocationSearch ? (<Grid container spacing={2}>
            <Grid item xs={12}>
              <AgreementInfo
                agreement={agreement}
                showAgreementTable={true}
                formType="edit"
                onAgreementInfoUpdate={onAgreementInfoUpdate}
                isEmPhUpdated={isEmPhUpdated}
                isNameUpdated={isNameUpdated}
                isAddressUpdated={isAddressUpdated}
                onEnableCustomerNameEdit={onEnableCustomerNameEdit}
                onEnablePhoneEmailEdit={onEnablePhoneEmailEdit}
                onEnableLocationEdit={onEnableLocationEdit}
                onSearchLocationClick={() => {
                  resetSearchState();
                  setShowLocationSearch(true);
                }}
              />
            </Grid>
            <Grid item xs={12}>
              {eqiGrid && (
                <EquipmentsTable
                  selectedInvoice={agreement}
                  showCheckboxes={true}
                  onAgreementUnitSizeExceed={handleOnAgreementUnitSizeExceed}
                  dealer={dealer}
                  allowedUnits={allowedUnits}
                />
              )}

              {loadingMsg && (
                <Typography
                  variant="info"
                  component="subtitle1"
                  align="left"
                  sx={{ fontSize: "14px" }}
                >
                  {loadingMsg}{" "}
                  {newBtn && (
                    <Button
                      color="secondary"
                      variant="contained"
                      size="small"
                      onClick={handleAddEquipmentsGrid}
                      disabled={ctxStEquipments.lenght >= allowedUnits}
                    >
                      Add Equipment
                    </Button>
                  )}
                </Typography>
              )}
            </Grid>
          </Grid>
          ) : (
            <Grid container spacing={2}>

              {/* SEARCH FIELDS */}
              <Grid item xs={12}>
                <Stack spacing={2}>

                  {/*  RADIO BUTTONS */}
                  <RadioGroup
                    row
                    value={searchType}
                    onChange={(e) => setSearchType(e.target.value)}
                  >
                    <FormControlLabel value="customerId" control={<Radio />} label="Customer ID" />
                    <FormControlLabel value="address" control={<Radio />} label="Address" />
                  </RadioGroup>

                  {/*  INPUT FIELDS BASED ON SELECTION */}
                  <Stack direction="row" spacing={2} alignItems="center">

                    {searchType === "customerId" && (
                      <TextField
                        label="Customer ID"
                        value={searchAddress.customerId || ""}
                        onChange={(e) =>
                          handleSearchInputChange("customerId", e.target.value)
                        }
                      />
                    )}

                    {searchType === "address" && (
                      <>
                        <TextField
                          label="Street"
                          value={searchAddress.addressLine1}
                          onChange={(e) =>
                            handleSearchInputChange("addressLine1", e.target.value)
                          }
                        />

                        <TextField
                          label="Unit"
                          value={searchAddress.unit || ""}
                          onChange={(e) =>
                            handleSearchInputChange("unit", e.target.value)
                          }
                          disabled={!searchAddress.addressLine1} // enable only after street
                        />
                      </>
                    )}

                    {/* ACTION BUTTONS */}
                    <Button
                      variant="contained"
                      onClick={handleLocationSearch}
                      disabled={isSearchDisabled}
                    >
                      Search
                    </Button>

                    <Button
                      variant="outlined"
                      onClick={() => {
                        resetSearchState(); //  clear fields
                        setShowLocationSearch(false);
                      }}
                    >
                      Cancel
                    </Button>
                  </Stack>
                </Stack>
              </Grid>

              {/*  SEARCH RESULTS GRID HERE */}
              <Grid item xs={12}>

                {searchResults.length > 0 && (

                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Location Id</TableCell>
                        <TableCell>Street</TableCell>
                        <TableCell>City</TableCell>
                        <TableCell>State</TableCell>
                        <TableCell>Zipcode</TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {searchResults.map((row) => (
                        <TableRow
                          key={row.id}
                          hover
                          style={{ cursor: "pointer" }}
                          onClick={() => handleLocationSelect(row)}
                        >
                          <TableCell>{row.id}</TableCell>
                          <TableCell>{row.address?.street}</TableCell>
                          <TableCell>{row.address?.city}</TableCell>
                          <TableCell>{row.address?.state}</TableCell>
                          <TableCell>{row.address?.zip}</TableCell>
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>

                )}

              </Grid>

            </Grid>

          )}

        </DialogContent>
        <DialogActions>
          <Grid container spacing={2}>
            {!showLocationSearch && (
              <Grid item>
                {isExceedingLimit && (
                  <Typography
                    variant="warning"
                    component="span"
                    sx={{ ml: "10px" }}
                  >

                    Equipment list must not be greater than{" "}
                    {allowedUnits}.
                  </Typography>
                )}
                {saveError && (
                  <Typography
                    variant="warning"
                    component="span"
                    sx={{ ml: "10px" }}
                  >
                    {saveError}
                  </Typography>
                )}
                {saveMsg && (
                  <Typography
                    variant="warning"
                    component="span"
                    sx={{ ml: "10px" }}
                  >
                    {saveMsg}
                    {/* <GradientCircularProgress size="20px" /> */}
                  </Typography>
                )}
              </Grid>)}
            <Box sx={{ flexGrow: 1 }} />
            <Grid item>
              {!showLocationSearch && (
                <>
                  <Button
                    onClick={() => handleSave(false)}
                    disabled={
                      !isProductValid ||
                      disableSaveBtn ||
                      isExceedingLimit ||
                      isOriginalPlanInvalid ||
                      isRenewedAgreementInvalid ||
                      !!installedDateError
                    }
                  >
                    Save
                  </Button>
                  <Button
                    onClick={handleSubmitClick}
                    disabled={!isProductValid ||
                      disableConfirmBtn ||
                      formSubmitted ||
                      isExceedingLimit ||
                      isOriginalPlanInvalid ||
                      isRenewedAgreementInvalid ||
                      !!installedDateError ||
                      isAdminWithJBWAgreement}
                  >
                    Submit
                  </Button>

                  <Button onClick={handleClose} disabled={disableCancelBtn}>
                    Cancel
                  </Button>
                </>
              )}
            </Grid>
          </Grid>
        </DialogActions>
      </Dialog>

      {/* Dealer Mismatch Confirmation Popup */}
      {/* Dealer Mismatch Confirmation Popup */}
      <Dialog
        open={dealerMismatchPopup}
        onClose={(event, reason) => {
          if (reason === "backdropClick") return;

          setDealerMismatchPopup(false);
          setMismatchDealerInfo(null);
          setMismatchAgreementData(null);
        }}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            padding: 1,
            width: 520,
          },
        }}
      >
        <DialogTitle
          sx={{
            fontWeight: 600,
            fontSize: "1.5rem",
            pb: 1,
          }}
        >
          Dealer Mismatch Confirmation
        </DialogTitle>

        <DialogContent dividers>
          <Typography
            sx={{
              mb: 3,
              fontSize: "1rem",
              color: "text.secondary",
            }}
          >
            The entered agreement belongs to a different dealer.
            Please review the details below and confirm whether
            you want to continue.
          </Typography>

          {/* Entered Dealer */}
          <Box
            sx={{
              mb: 3,
              p: 2,
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              backgroundColor: "#fafafa",
            }}
          >
            <Typography
              sx={{
                fontWeight: 600,
                mb: 1,
                color: "#d32f2f",
              }}
            >
              Agreement Dealer
            </Typography>

            <Typography sx={{ mb: 0.5 }}>
              <strong>Dealer Id:</strong>{" "}
              {mismatchDealerInfo?.enteredDealerId}
            </Typography>

            <Typography>
              <strong>Dealer Name:</strong>{" "}
              {mismatchDealerInfo?.enteredDealerName}
            </Typography>
          </Box>

          {/* Selected Dealer */}
          <Box
            sx={{
              p: 2,
              border: "1px solid #e0e0e0",
              borderRadius: 2,
              backgroundColor: "#fafafa",
            }}
          >
            <Typography
              sx={{
                fontWeight: 600,
                mb: 1,
                color: "#1976d2",
              }}
            >
              Selected Dealer
            </Typography>

            <Typography sx={{ mb: 0.5 }}>
              <strong>Dealer Id:</strong>{" "}
              {mismatchDealerInfo?.selectedDealerId}
            </Typography>

            <Typography>
              <strong>Dealer Name:</strong>{" "}
              {mismatchDealerInfo?.selectedDealerName}
            </Typography>
          </Box>
        </DialogContent>

        <DialogActions
          sx={{
            px: 3,
            py: 2,
            justifyContent: "flex-end",
            gap: 1,
          }}
        >
          <Button
            variant="outlined"
            color="inherit"
            onClick={() => {
              setDealerMismatchPopup(false);
              setMismatchDealerInfo(null);
              setMismatchAgreementData(null);
            }}
            sx={{
              minWidth: 100,
              textTransform: "none",
            }}
          >
            Cancel
          </Button>

          <Button
            variant="contained"
            color="primary"
            onClick={() => {
              setDealerMismatchPopup(false);
              processRenewedAgreement(mismatchAgreementData);
            }}
            sx={{
              minWidth: 120,
              textTransform: "none",
              fontWeight: 600,
            }}
          >
            Continue
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default AgreementEquimentDialog;